import { useEffect, useState } from "react";
import { Breakpoint } from "../utils/media-query";
import Head from "next/head";

const PrivacyPolicy = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const [isDesktop, isMobile] = Breakpoint();

  return (
    <>
      <Head>
        <title>Privacy Policy | Aurum Lab</title>
        {/* <meta
          name="description"
          content="Toko perhiasan emas asli 9K & berlian online. Menjual cincin emas, kalung emas, anting emas, liontin emas & gelang emas. Bersertifikat & FREE ongkir"
        /> */}
      </Head>
      <main>
        {isMounted && (
          <div className="mt-3">
            <div className={isDesktop ? "container" : "container-mobile"}>
              <h2 className="center mb-2">Privacy Policy</h2>
              <p className="mb-1 text-justify">
                Welcome to the Aurum Lab platform operated by PT Kreasi Loyal
                Mandiri (individually and collectively referred to as “
                <b>Aurum Lab</b>” or “<b>we</b>“). This Privacy Policy (“
                <b>Privacy Policy</b>” or “<b>Policy</b>“) is our commitment to
                always protect and respect the personal information of users of
                the website www.theaurumlab.com. Aurum Lab takes its
                responsibility seriously under applicable privacy laws (“
                <b>Privacy Laws</b>“) and is committed to respecting the privacy
                rights and concerns of all users of our Site. We acknowledge the
                importance of the personal data you have entrusted to us and
                believe that it is our responsibility to manage, protect, and
                process your personal data properly.
              </p>
              <p className="mb-1 text-justify">
                This Privacy Policy is designed to help you understand how we
                collect, use, disclose, and/or process personal data that you
                have entrusted to us and/or that we possess about you, both now
                and in the future, and to help you make informed decisions
                before disclosing any information and personal data.
              </p>
              <p className="mb-1 text-justify">
                By accessing and using the Site, you are deemed to have read,
                understood, and agreed to our collection, processing,
                disclosure, and use of your information and personal data as
                described below. The Privacy Policy may change or be updated at
                any time without prior notice and/or announcement.
              </p>
              <h3 className=" mb-1">1. COLLECTION OF PERSONAL DATA</h3>
              <p className="mb-1 text-justify">
                We request information that we deem necessary to support our
                Site when you register an account to use and access the Site.
                This may include, but is not limited to, your personal data such
                as name, address, phone number, email address, credit card
                number, and bank account information, shipping history, items
                shipped, requested or purchased item descriptions, and log
                information available on our server, internet protocol address,
                device activity information, browser type, request date and
                time, referring URL, operating system, and viewed page
                statistics, as well as other useful or necessary information
                (“Personal Data”) to provide you with the best service from our
                Site.
              </p>

              <h3 className=" mb-1">2. USE OF COLLECTED INFORMATION</h3>
              <p className="mb-1 text-justify">
                All personal information/data that we obtain from you
                voluntarily during registration will be stored, protected, and
                used in accordance with data protection laws and this privacy
                policy. All collected information is used for the following
                purposes:
              </p>
              <div className="mb-1 ">
                <ul className="container-mobile">
                  <li>Facilitating your shopping process</li>
                  <li>Simplifying payment transactions</li>
                  <li>Ensuring order delivery</li>
                  <li>Supporting Aurum Lab’s administration</li>
                  <li>
                    Aurum Lab may, under certain circumstances, need to use or
                    disclose user personal information for law enforcement
                    purposes or for compliance with applicable legal
                    requirements and regulations.
                  </li>
                </ul>
              </div>

              <h3 className=" mb-1">3. PROMOTIONS AND EVENTS</h3>
              <p className="mb-1 text-justify">
                Periodically, we hold special promotions and events, the details
                of which will be communicated to you.
              </p>

              <h3 className=" mb-1">4. AURUM LAB EMAIL SUBSCRIPTION</h3>
              <p className="mb-1 text-justify">
                You will have the option to receive promotional emails and Aurum
                Lab information. If you choose to subscribe, Aurum Lab will send
                you periodic emails containing information about promotions,
                products, and updates. We only use your email for Aurum Lab
                purposes and will not share, sell, or provide your email data to
                third parties without consent. You can unsubscribe at any time;
                each email you receive will include an unsubscribe option.
              </p>

              <h3 className=" mb-1">5. COOKIES</h3>
              <p className="mb-1 text-justify">
                We may use various technologies to collect and store information
                when you use and access the Site, which may include the use of
                cookies or similar technologies. Cookies are small files that
                are automatically placed on your computer device to identify and
                monitor your network connection, allowing you to use and access
                the Site optimally. Cookies also automatically help our system
                identify the browser you’re using and can provide additional
                services such as storing data about what you’ve purchased
                through our Site.
              </p>

              <h3 className=" mb-1">6. CHANGES TO THE PRIVACY POLICY</h3>
              <p className="mb-1 text-justify">
                Aurum Lab may disclose data/information upon request from law
                enforcement agencies or other government bodies, or if such
                information can assist investigations related to public safety.
                Aurum Lab also reserves the right to change the privacy policy
                in accordance with the terms and conditions applicable from time
                to time.
              </p>

              <h3 className=" mb-1">7. ACCOUNT DELETION</h3>
              <p className="mb-1 text-justify">
                You have the right to delete your account on the Aurum Lab
                platform. If you wish to delete your account, please contact us
                using the provided contact information. Please note that account
                deletion may result in the permanent loss of your data and
                access to the platform.
              </p>
              <p className="mb-1 text-justify">Accessing Your Data</p>
              <p className="mb-1 text-justify">
                Additionally, you have the right to access and retrieve your
                personal data stored by us. If you wish to exercise this right
                or have any inquiries about your personal data, please contact
                us using the provided contact information.
              </p>

              <h2 className="center my-5">Kebijakan Privasi</h2>

              <p className="mb-1 text-justify">
                Selamat datang di platform Aurum Lab yang dioperasikan oleh PT
                Kreasi Loyal Mandiri (secara sendiri-sendiri dan bersama-sama
                juga disebut “<b>Aurum Lab</b>” atau “<b>kami</b>“). Kebijakan
                privasi (“<b>Kebijakan Privasi</b>” atau “<b>Kebijakan</b>“) ini
                merupakan suatu komitmen kami untuk selalu melindungi dan
                menghargai setiap informasi pribadi pengguna situs
                www.theaurumlab.com. Aurum Lab dengan serius bertanggung jawab
                berdasarkan peraturan perundang-undangan tentang privasi yang
                berlaku (“<b>Undang-Undang Privasi</b>“) dan berkomitmen untuk
                menghormati hak dan masalah privasi semua Pengguna Situs kami.
                Kami mengakui pentingnya data pribadi yang telah Anda percayakan
                kepada kami dan percaya bahwa merupakan tanggung jawab kami
                untuk mengelola, melindungi dan mengolah data pribadi Anda
                dengan baik.
              </p>
              <p className="mb-1 text-justify">
                Kebijakan Privasi ini dirancang untuk membantu Anda memahami
                bagaimana kami mengumpulkan, menggunakan, mengungkapkan dan/atau
                mengolah data pribadi yang telah Anda percayakan kepada kami
                dan/atau kami miliki tentang Anda, baik di masa sekarang maupun
                di masa mendatang, serta untuk membantu Anda membuat keputusan
                yang tepat sebelum mengungkapkan segala informasi dan juga Data
                Pribadi
              </p>
              <p className="mb-1 text-justify">
                Dengan mengakses dan menggunakan Situs, anda dianggap telah
                membaca, memahami, dan memberikan persetujuan kepada Kami atas
                pengumpulan, pemrosesan, pengungkapan, dan penggunaan informasi
                dan juga data pribadi anda sebagaimana diuraikan di bawah ini.
                Kebijakan Privasi dapat berubah atau diperbaharui sewaktu-waktu
                tanpa ada pemberitahuan dan/atau pengumuman terlebih dahulu.
              </p>
              <h3 className=" mb-1">1. PEROLEHAN DATA PRIBADI</h3>
              <p className="mb-1 text-justify">
                Kami meminta informasi yang dianggap perlu untuk menunjang Situs
                Kami sewaktu anda mendaftarkan akun untuk dapat menggunakan dan
                mengakses Situs, termasuk, namun tidak terbatas pada data
                pribadi anda seperti nama, alamat, nomor telepon, alamat email,
                nomor kartu kredit dan informasi rekening bank, riwayat
                pengiriman, barang yang terkirim, deskripsi barang yang diminta
                atau dibeli dan juga informasi log yang tersedia di server Kami,
                alamat protokol internet, informasi aktivitas perangkat, jenis
                peramban, tanggal dan waktu permintaan, URL perujuk, sistem
                operasi, serta statistik halaman yang dilihat dan informasi lain
                yang akan berguna atau diperlukan (“<b>Data Pribadi</b>”) untuk
                memberi anda pelayanan terbaik Kami dari Situs.
              </p>

              <h3 className=" mb-1">
                2. PENGGUNAAN INFORMASI YANG KAMI KUMPULKAN
              </h3>
              <p className="mb-1 text-justify">
                Semua informasi/data pribadi yang kami dapatkan dari Anda secara
                sukarela saat pendaftaran akan kami simpan, lindungi dan gunakan
                sesuai dengan undang-undang perlindungan data dan kebijakan
                privasi ini. Semua informasi yang dikumpulkan kami gunakan untuk
                menyediakan layanan terbaik untuk Anda. Semua informasi kami
                gunakan untuk hal-hal berikut:
              </p>
              <div className="mb-1 ">
                <ul className="container-mobile">
                  <li>Mempermudah proses belanja Anda</li>
                  <li>Mempermudah transaksi pembayaran</li>
                  <li>Kepentingan pengiriman pesanan</li>
                  <li>Kepentingan administrasi Aurum Lab</li>
                  <li>
                    Aurum Lab pada saat kondisi tertentu mungkin perlu untuk
                    menggunakan ataupun mengungkapkan informasi pribadi pengguna
                    untuk tujuan penegakan hukum atau untuk pemenuhan
                    persyaratan hukum dan peraturan yang berlaku.
                  </li>
                </ul>
              </div>

              <h3 className=" mb-1">3. PROMOSI DAN EVEN</h3>
              <p className="mb-1 text-justify">
                Secara berkala kami mengadakan promosi dan event khusus yang
                detailnya akan diberitahukan kepada Anda.
              </p>

              <h3 className=" mb-1">4. BERLANGGANAN EMAIL AURUM LAB</h3>
              <p className="mb-1 text-justify">
                Anda akan mendapatkan pilihan untuk ingin menerima email promosi
                dan informasi Aurum Lab. Jika Anda memilih untuk berlangganan
                maka Aurum Lab akan mengirimkan email secara berkala kepada Anda
                yang berisikan informasi tentang promosi, produk, dan informasi.
                Kami hanya menggunakan email Anda untuk keperluan Aurum Lab dan
                tidak akan membagi, menjual, atau memberikan data email Anda
                kepada pihak ketiga tanpa adanya persetujuan. Anda dapat memilih
                untuk berhenti berlangganan kapan saja, pada setiap email yang
                Anda terima akan terdapat pilihan untuk berhenti berlangganan.
              </p>

              <h3 className=" mb-1">5. COOKIES</h3>
              <p className="mb-1 text-justify">
                Kami dapat menggunakan berbagai macam teknologi untuk
                mengumpulkan dan menyimpan informasi saat anda menggunakan dan
                mengakses Situs, yang mana teknologi tersebut dapat mencakup
                penggunaan cookies atau teknologi serupa. Cookies adalah file
                kecil yang secara otomatis akan mengambil tempat di dalam
                perangkat komputer anda untuk mengidentifikasi dan memantau
                koneksi jaringan anda, sehingga memungkinkan anda untuk
                menggunakan dan mengakses Situs secara optimal. Cookies juga
                secara otomatis akan membantu sistem kami untuk mengetahui
                browser apa yang anda gunakan dan dapat memberikan anda layanan
                tambahan seperti misalnya penyimpanan data mengenai apa saja
                yang telah anda beli melalui Situs kami.
              </p>

              <h3 className=" mb-1">6. PERUBAHAN DALAM KEBIJAKAN PRIVASI</h3>
              <p className="mb-1 text-justify">
                Aurum Lab dapat mengungkapkan data/informasi atas permintaan
                dari lembaga penegak hukum atau badan pemerintah lainnya, atau
                jika informasi tersebut dapat membantu penyelidikan yang
                berhubungan dengan keselamatan orang banyak. Aurum Lab juga
                memiliki hak untuk mengubah kebijakan privasi sesuai dengan
                syarat dan ketentuan yang berlaku dari waktu ke waktu.
              </p>

              <h3 className=" mb-1">7. PENGHAPUSAN AKUN</h3>
              <p className="mb-1 text-justify">
                Anda memiliki hak untuk menghapus akun Anda di platform Aurum
                Lab. Jika Anda ingin menghapus akun Anda, silakan hubungi kami
                menggunakan informasi kontak yang disediakan. Harap dicatat
                bahwa penghapusan akun dapat mengakibatkan hilangnya data Anda
                secara permanen dan akses ke platform.
              </p>
              <p className="mb-1 text-justify">Akses ke Data Anda</p>
              <p className="mb-1 text-justify">
                Selain itu, Anda memiliki hak untuk mengakses dan mengambil
                kembali data pribadi Anda yang disimpan oleh kami. Jika Anda
                ingin menggunakan hak ini atau memiliki pertanyaan tentang data
                pribadi Anda, silakan hubungi kami menggunakan informasi kontak
                yang disediakan.
              </p>
            </div>
          </div>
        )}
      </main>
    </>
  );
};
export default PrivacyPolicy;
